import { Component } from 'react'
import { RequestAlumno, RequestDomiciliacionBancaria } from "objects/requests"

/**
 * Clase donde se guardan las peticiones que se van a usar
 */
export default class Requests extends Component {

    /**
     * Hace la petición para editar el usuario
     * 
     * @param {Int} id 
     * @param {Function} getValues 
     * @param {Function} callbackOk 
     * @param {Function} callbackError 
     */
    createAlumno(getValues, callbackOk = () => {}, callbackError = () => {}) {
        var formData = new FormData()
        formData.append("nombre",                  getValues("nombre").toUpperCase())
        formData.append("apellido1",               getValues("apellido1").toUpperCase())
        formData.append("apellido2",               getValues("apellido2").toUpperCase())
        formData.append("email",                   getValues("email").toUpperCase())
        formData.append("email2",                  getValues("email2").toUpperCase())
        formData.append("numero_documento",        getValues("numero_documento").toUpperCase())
        formData.append("id_tipo_documento",       getValues("id_tipo_documento"))
        formData.append("nombre_via",              getValues("nombre_via").toUpperCase())
        formData.append("id_tipo_via",             getValues("id_tipo_via"))
        formData.append("cod_postal",              getValues("cod_postal"))
        formData.append("pais_nacimiento",         getValues("pais_nacimiento").toUpperCase())
        formData.append("id_provincia",            getValues("id_provincia"))
        formData.append("id_sexo",                 getValues("id_sexo"))
        formData.append("id_provincia_nacimiento", getValues("id_provincia_nacimiento"))
        formData.append("municipio",               getValues("municipio").toUpperCase())
        formData.append("municipio_nacimiento",    getValues("municipio_nacimiento").toUpperCase())
        formData.append("telefono1",               getValues("telefono1"))
        formData.append("telefono2",               getValues("telefono2"))
        formData.append("tlfno_movil1",            getValues("tlfno_movil1"))
        formData.append("tlfno_movil2",            getValues("tlfno_movil2"))
        if(getValues("foto_logo")[0])
            formData.append("foto_logo",           getValues("foto_logo")[0])

        new RequestAlumno().create(formData, callbackOk, callbackError)
    }


    /**
     * Hace la peticion para editar los datos bancarios del usuario
     * 
     * @param {Int}      id 
     * @param {Function} getValues 
     * @param {Function} callbackOk 
     * @param {Function} callbackError 
     */
    createDatosBancarios(id, getValues, callbackOk = () => {}, callbackError = () => {}) {
        var formData = new FormData()
        formData.append("codigo_pais",        getValues("codigo_pais"))
        formData.append("numero_control",     getValues("numero_control"))
        formData.append("cuenta1",            getValues("cuenta1"))
        formData.append("iban",               getValues("iban").toUpperCase())
        formData.append("nombre_deudor",      getValues("nombre_deudor").toUpperCase())
        formData.append("referencia_mandato", getValues("referencia_mandato").toUpperCase())

        new RequestDomiciliacionBancaria().edit(id, formData, callbackOk, callbackError)
    }
}
